import React, { useState } from "react";
import axios from "axios";
import { endpoints } from "../apiConfig";
import { getAuthHeader } from "../session";
import { setWageToken } from "../wageUnlock";
import { colors, fonts, space, radius, buttonPrimary, buttonSecondary, inputBase } from "../theme";

// A password re-check that stands apart from whatever login already got someone here, before wage
// information (pay type, rate, salary, payroll totals) is shown or changed anywhere in the app.
export default function WageUnlockModal({ onUnlock, onClose }) {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const res = await axios.post(endpoints.wageUnlock, { password }, { headers: getAuthHeader() });
      setWageToken(res.data.wage_token);
      onUnlock(res.data.wage_token);
    } catch (err) {
      setError(err.response?.data?.error || "That didn't work. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={styles.bg} onClick={onClose}>
      <div style={styles.box} role="dialog" aria-label="Enter your account password" onClick={(e) => e.stopPropagation()}>
        <h2 style={styles.heading}>Wage information is protected</h2>
        <p style={styles.text}>Enter your restaurant account's password to view or change pay information. This is separate from any PIN, and only unlocks wage data for this visit.</p>
        <form onSubmit={submit}>
          <input style={inputBase} type="password" placeholder="Account password" value={password} onChange={(e) => setPassword(e.target.value)} autoFocus required aria-label="Account password" />
          {error && <div style={styles.error} role="alert">{error}</div>}
          <div style={{ display: "flex", gap: space[2], marginTop: space[3] }}>
            <button type="button" style={buttonSecondary} onClick={onClose}>Cancel</button>
            <button type="submit" style={{ ...buttonPrimary, flex: 1 }} disabled={busy}>{busy ? "Checking…" : "Unlock"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

const styles = {
  bg: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2000, padding: space[3] },
  box: { background: colors.surface, borderRadius: radius.lg, padding: space[5], width: "100%", maxWidth: 380 },
  heading: { fontFamily: fonts.display, fontSize: 18, fontWeight: 600, margin: `0 0 ${space[2]}`, color: colors.textPrimary },
  text: { fontFamily: fonts.body, fontSize: 13, color: colors.textSecondary, margin: `0 0 ${space[3]}`, lineHeight: 1.5 },
  error: { fontFamily: fonts.body, fontSize: 13, color: "#b91c1c", marginTop: space[2] },
};
